import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectUpdateArgs } from "types/generated";

import { INTENT_PROJECT_BASIC_FRAGMENT } from "../gql";

export const UPDATE_INTENT_PROJECT: TypedDocumentNode<
  { intentProjectUpdate: IntentProject },
  MutationIntentProjectUpdateArgs
> = gql`
  mutation UpdateIntentProject($id: ID!, $name: String, $description: String, $space: ID) {
    intentProjectUpdate(id: $id, name: $name, description: $description, space: $space) {
      ...IntentProjectBasic
    }
  }
  ${INTENT_PROJECT_BASIC_FRAGMENT}
`;
